import { interval, map, Observable, of, startWith, Subscription, switchMap } from 'rxjs';

import { ChangeDetectorRef, inject, NgZone, OnDestroy, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  pure: false
})
export class TimeAgoPipe implements PipeTransform, OnDestroy {
  private timeUpdate$!: Observable<string>;
  private interval = 60000;
  private subcription?: Subscription;
  #ngZone = inject(NgZone);
  #cdr = inject(ChangeDetectorRef);

  transform(value: string): Observable<string> {
    this.#ngZone.runOutsideAngular(() => { //Angularの変更検出メカニズムから離れた場所で処理を行う
      this.timeUpdate$ = interval(this.interval).pipe(
        startWith(0),
        switchMap(() => of(this.formatTimeAgo(value))),
        map(text => {
          this.#cdr.markForCheck();
          return text;
        })
      );
      this.subcription = this.timeUpdate$.subscribe();
    });
    return this.timeUpdate$;
  }
  formatTimeAgo(value: string): string {
    const now = new Date();
    const target = new Date(value);
    const diff = now.getTime() - target.getTime();
    const seconds = Math.floor(diff / 1000);

    if (seconds < 60) {
      return `${seconds}秒前`;
    }
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
      return `${minutes}分前`;
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}時間${remainingMinutes}分前`;
  }
  ngOnDestroy() {
    if (this.subcription) {
      this.subcription.unsubscribe();
    }
  }
}
